
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 6.2H17.9v-3c0-.1 0-.2-.1-.2h-.2l-6.8 4c-.1 0-.1.1-.1.2s0 .2.1.2l6.8 4h.2c.1 0 .1-.1.1-.2v-3H29v20.9L6.1 29V13.3c0-.6-.4-1-1-1s-1 .4-1 1V30c0 .6.4 1 1 1l24.9.1c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7V7.2c0-.6-.4-1-1-1z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M5.2 9.4a2.2 2.2 0 100-4.4 2.2 2.2 0 000 4.4z","fill":"#F9A91E"}})])
          )
        }
      }
    